'use client';

import { cn } from '@eliadmin/core/src/utils/style-utils';

export function ProductBadge({
  background,
  color,
  text,
  className,
}: {
  background: string;
  color: string;
  text: string;
  className?: string;
}) {
  return (
    <div
      className={cn(
        'ea-product-badge',
        'flex h-[24px] items-center justify-center rounded-[8px] px-[10px] text-[10px] font-medium capitalize antialiased sm:h-[26px]',
        className,
      )}
      style={{ backgroundColor: background, color: color ?? '#ffffff' }}
    >
      {text}
    </div>
  );
}
